import { RacemapAPIClient } from '@racemap/utilities/api-client';
import type { KeyData } from '@racemap/utilities/types/events';
import { Component } from 'react';
import { Form, FormControl, FormGroup, FormLabel } from 'react-bootstrap';

type CheckKeyInputProps = {
  id: string;
  usedOk?: boolean;
  disabled: boolean;
  starterKey: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onReceivedKey: (keyData: KeyData) => void;
};

type CheckKeyInputState = {
  infoMessage: string;
  validationState: string;
};

const VALIDATION_STATES = {
  OK: 'success',
  FAIL: 'error',
  PENDING: 'warning',
  TOO_SHORT: 'warning',
  EMPTY: null as string,
};

const apiClient = RacemapAPIClient.fromWindowLocation();

export default class CheckKeyInput extends Component<CheckKeyInputProps, CheckKeyInputState> {
  static defaultProps = {
    usedOk: false,
    disabled: true,
    onChange: () => {},
  };

  constructor(props: CheckKeyInputProps) {
    super(props);
    this.state = {
      validationState: VALIDATION_STATES.EMPTY,
      infoMessage: '',
    };
  }

  componentDidMount() {
    this.checkKey();
  }

  componentDidUpdate(prevProps: CheckKeyInputProps) {
    if (prevProps.starterKey !== this.props.starterKey) {
      this.checkKey();
    }
  }

  checkKey = async () => {
    try {
      // no key in input
      if (this.props.starterKey === '') {
        this.setState({
          validationState: VALIDATION_STATES.EMPTY,
          infoMessage: '',
        });
        return;
      }

      // entered key is to short
      if (this.props.starterKey.length < 6) {
        this.setState({
          validationState: VALIDATION_STATES.TOO_SHORT,
          infoMessage: 'Key is too short.',
        });
        return;
      }

      this.setState({
        validationState: VALIDATION_STATES.PENDING,
        infoMessage: 'Request Key State.',
      });

      const keyData = await apiClient.checkEventStarterKey(this.props.starterKey, {
        usedOk: this.props.usedOk,
      });

      this.setState({
        validationState: VALIDATION_STATES.OK,
        infoMessage: 'Key is valid.',
      });
      this.props.onReceivedKey(keyData);
    } catch (err) {
      if (err.serverResponse != null) {
        if (err.serverResponse.status === 403) {
          this.setState({
            validationState: VALIDATION_STATES.FAIL,
            infoMessage: 'Key has been used.',
          });
          return;
        }
        if (err.serverResponse.status === 404) {
          this.setState({
            validationState: VALIDATION_STATES.FAIL,
            infoMessage: 'Key is invalid.',
          });
          return;
        }
      }
      this.setState({
        validationState: VALIDATION_STATES.FAIL,
        infoMessage: "Key couldn't be validated.",
      });
      console.error(err.message);
    }
  };

  render() {
    return (
      <Form>
        <FormGroup validationState={this.state.validationState}>
          <FormLabel>Key/Passcode:</FormLabel>
          <FormControl
            type="text"
            value={this.props.starterKey}
            readOnly={this.props.disabled}
            onChange={this.props.onChange}
            placeholder="Enter your key here..."
            id={this.props.id}
          />
          <FormControl.Feedback />
          <Form.Text>{this.state.infoMessage}</Form.Text>
        </FormGroup>
      </Form>
    );
  }
}
